import React from 'react';
import * as Icons from '../icons';
import { Modal, ModalBody, Button } from 'reactstrap';

export type LinkModalProps = {
    url: string;
    isOpen: boolean;
    closeModal: () => void;
    onChangeUrl: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSaveLink: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onRemoveLink: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export function LinkModal(props: LinkModalProps) {
    const {
        url,
        closeModal,
        onChangeUrl,
        onSaveLink,
        onRemoveLink,
        isOpen,
        ...rest
    } = props;
    return (
        <Modal {...rest} centered toggle={closeModal} isOpen={isOpen}>
            <ModalBody>
                <h3 className='text-modal modal__title'>Edit link</h3>
                <button
                    className='modal-close'
                    type='button'
                    onClick={closeModal}
                >
                    <Icons.X />
                </button>
                <input
                    className='form-control mb-3'
                    autoFocus
                    value={url}
                    onChange={onChangeUrl}
                />
                <div className='modal-buttons'>
                    <Button
                        color='danger'
                        size='sm'
                        type='button'
                        onClick={onRemoveLink}
                    >
                        Remove
                    </Button>
                    <Button
                        color='primary'
                        size='sm'
                        type='button'
                        onClick={onSaveLink}
                    >
                        Save
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
}
